import ReactSelect from 'react-select';
import useReportFieldError from '@/hooks/useReportFieldError';

const SelectInputFormik = ({
  title,
  options,
  id,
  name,
  handleChange,
  errors,
  touched,
  ...props
}) => {
  useReportFieldError(name);
  return (
    <div className='flex flex-col gap-1'>
      <label htmlFor={id} className='max-lg:text-sm'>
        {title}
      </label>
      <ReactSelect
        name={name}
        id={id}
        placeholder=''
        onChange={handleChange}
        options={options}
        classNamePrefix='react-select'
        styles={customStyles}
        {...props}
      />
      {errors[name] && touched[name] ? (
        <p className='text-xs text-red-500 sm:text-sm'>{errors[name]}</p>
      ) : null}
    </div>
  );
};

export default SelectInputFormik;

export const customStyles = {
  control: (provided) => ({
    ...provided,
    boxShadow: 'none',
    padding: '0.2rem',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: 'none',
    },
    border: '1px solid #cbd5e1',
    borderRadius: '12px',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#1f2b7b' : 'white',
    color: state.isFocused ? 'white' : 'black',

    border: 'none',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#1f2b7b',
      color: 'white',
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (provided) => ({
    ...provided,
    borderColor: 'white',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  }),
};
